import React from 'react';
import styled from 'styled-components';
import { colors } from '../../styles';
import { Dismissible } from '../../utils/dismissible';
import { Checkbox } from '../inputs';
import { Icon } from '../icons';
import { textSizesPx, spaceSizesPx } from '@nauto/core';

interface MultiSelectProps {
  className?: string;
  buttonContent: any;
  menuTitle?: string;
  menuItems: any[];
  defaultSelectedItems?: any[];
  onChangeInCloseMenu?: (selectedItems: any[]) => void;
  onChange?: (selectedItems: any[]) => void;
}

interface MultiSelectState {
  isOpened: boolean;
}

class MultiSelect extends React.Component<MultiSelectProps, MultiSelectState> {
  selectedItems: any[] = this.props.defaultSelectedItems || [];

  state = {
    isOpened: false,
  };

  openMenu = () => this.setState({ isOpened: true });

  closeMenu = e => {
    const { onChangeInCloseMenu } = this.props;
    e.stopPropagation();
    this.setState({ isOpened: false });

    if (onChangeInCloseMenu) {
      onChangeInCloseMenu(this.selectedItems);
    }
  };

  changeSelectedList = e => {
    const { onChange } = this.props;
    const checkbox = e.currentTarget;
    const item = checkbox.name;
    const idx = this.selectedItems.indexOf(item);

    if (checkbox.checked) {
      this.selectedItems = [...this.selectedItems, item];
    } else if (idx !== -1) {
      this.selectedItems.splice(idx, 1);
    }
    if (onChange) {
      onChange(this.selectedItems);
    }
  };

  render() {
    const { className, buttonContent, menuTitle, menuItems } = this.props;
    const { isOpened } = this.state;

    return (
      <div className={className}>
        <div
          className={`multi-select-btn ${isOpened ? 'opened' : ''}`}
          onClick={this.openMenu}
        >
          <div>{buttonContent}</div>
          <Icon icon="caretDown" size="xl" baseColor={colors.blue500} />
        </div>
        {isOpened && (
          <Dismissible
            className="multi-select-menu"
            onClickAway={this.closeMenu}
          >
            {menuTitle && (
              <div className="multi-select-menu-title">{menuTitle}</div>
            )}
            <div className="multi-select-menu-items">
              {menuItems.map((item, key) => (
                <div key={key} className="multi-select-menu-item">
                  <Checkbox
                    name={item}
                    id={`multi-select-checkbox-${key}`}
                    size="sm"
                    onChange={this.changeSelectedList}
                    defaultChecked={this.selectedItems.some(
                      selected => selected === item,
                    )}
                  />
                  <label htmlFor={`multi-select-checkbox-${key}`}>{item}</label>
                </div>
              ))}
            </div>
          </Dismissible>
        )}
      </div>
    );
  }
}

const StyledMultiSelect = styled(MultiSelect)`
  position: relative;

  .multi-select-btn {
    cursor: pointer;
    display: flex;
    justify-content: center;
    align-items: center;
    box-shadow: 0px 1px 10px 1px ${colors.grey300};
    color: ${colors.grey900};
    font-size: ${textSizesPx.md};
    padding: 5px 25px;
    border: 1px solid ${colors.grey300};

    .icon {
      padding-left: 15px;
      height: ${spaceSizesPx.lg};
      width: ${spaceSizesPx.lg};
    }
    :hover {
      color: black;
      .icon > g {
        fill: black !important;
      }
    }
  }

  .multi-select-btn.opened {
    color: black;
    .icon > g {
      fill: black !important;
    }
  }

  .multi-select-menu {
    height: auto;
    position: absolute;
    top: 60px;
    right: 0;
    background: white;
    z-index: 1;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    box-shadow: 0px 1px 10px 1px ${colors.grey300};
    font-size: ${textSizesPx.md};
    padding: 15px 25px;
    border: 1px solid ${colors.grey300};
    min-width: 275px;

    .multi-select-menu-title {
      color: black;
      font-family: Circular-Bold;
      padding-bottom: 20px;
      text-align: left;
      width: 100%;
    }

    .multi-select-menu-items {
      overflow-y: auto;
      max-height: 165px;
      width: 100%;
      align-self: flex-start;

      ::-webkit-scrollbar {
        width: 5px;
      }
      ::-webkit-scrollbar-track {
        -webkit-box-shadow: inset 5px 0 0 rgba(0, 0, 0, 0.1);
        border-radius: 10px;
      }
      ::-webkit-scrollbar-thumb {
        border-radius: 10px;
        -webkit-box-shadow: inset 5px 0px 0px rgba(0, 0, 0, 0.35);
      }

      .multi-select-menu-item {
        padding-bottom: 15px;
        color: rgba(46, 47, 58, 0.65);

        input {
          margin-right: ${spaceSizesPx.md};
          margin-left: 2px;

          :checked {
            background-color: ${colors.blue500};
            box-shadow: 0 0 0 2px ${colors.blue500};
          }
          :hover {
            box-shadow: 0 0 0 2px ${colors.blue500};
          }
        }
        label {
          cursor: pointer;
          :hover {
            color: black;
          }
        }
      }
    }
  }
`;

export default StyledMultiSelect as any;
